/**
 * Client-side analytics helper.
 *
 * GA4 is loaded via Cloudflare Zaraz (configured in the Cloudflare dashboard,
 * not in this repo), so custom events are sent through `zaraz.track()`. Zaraz
 * forwards them to GA4 (and any other configured tools). These events still
 * need to be marked as "Key events" in the GA4 UI to count as conversions.
 */

interface Zaraz {
  track: (event: string, properties?: Record<string, unknown>) => void;
}

declare global {
  interface Window {
    zaraz?: Zaraz;
  }
}

/**
 * Fire a tracking event. Safe to call during SSR or before Zaraz has loaded —
 * it no-ops if `window.zaraz` is unavailable rather than throwing.
 */
export function track(
  event: string,
  properties?: Record<string, unknown>
): void {
  if (typeof window === "undefined") return;
  try {
    window.zaraz?.track(event, properties);
  } catch {
    // Never let analytics break a user interaction.
  }
}
